module.exports = __webpack_public_path__ + "img/Icon_Registro_de_Visitas_Hover.f936d795.svg";